import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams
} from "react-router-dom"
import { GlobalContext } from '../GlobalContext'
import { subscribe } from '../utils/pubsub'
import RedAlert from '../ui-elements/RedAlert'
import Button from '../formfields/Button'
import GreenAlert from '../ui-elements/GreenAlert'
import FormatQuestionAnsweredBy from './FormatQuestionAnsweredBy'
import { getDate } from '../utils/getDate'


type Props = {
    thisCheckPeriod: ObjectStringKeyAnyValue
}



function ManagerSignoffCompleted({
    thisCheckPeriod
}: Props) {

    const {
        tableData,
        sendMessageToWebsocket
    } = useContext(GlobalContext)

    const thisSignoff = thisCheckPeriod['managerSignoff'] || null


    return <div className={`
    rounded border flex flex-col text-sm px-4 py-2 
    ${thisSignoff['noteText'] ?
            ' bg-yellow-100 border-yellow-500 text-yellow-700 ' :
            ' bg-green-100 border-green-400 text-green-800 ' }
    `}>
        <p>
            Signed off

            {thisSignoff
                && thisSignoff['name']
                && ` by ${thisSignoff['name']}`}

            {thisSignoff
                && thisSignoff['email']
                && ` (${thisSignoff['email']})`}

            {thisSignoff
                && thisSignoff['timestamp']
                // && ` on ${thisCheckPeriod['managerSignoff']['timestamp']}`}
                && ` on ${getDate(`${thisSignoff['timestamp']}`, 'formattedDateAndTime')}.`}
        </p>    

        {thisSignoff && thisSignoff['noteText'] &&
            <p className="">
               <span className="font-bold">✏️  Note: </span> "{thisSignoff['noteText']}"
            </p>
        }

    </div>

}
export default ManagerSignoffCompleted